<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <collapseHeader @chooseAddress="(val) => $emit('chooseAddress', val)" />
        </div>

        <productTable ref="productTable" v-bind="$props" />
      </Collapse>
      <slot />
    </div>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse';
import collapseHeader from './collapseHeader.vue';
import productTable from './productTable.vue';

export default {
  components: {
    Collapse,
    collapseHeader,
    productTable
  },

  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => { return {}; }
    },
    contractId: {
      type: [String, Number],
      default: ''
    }
  },

  data () {
    return {
      productList: [],
      loading: false
    };
  },

  methods: {
    // 发布
    validate () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();

      return new Promise((resolve) => {
        if (!productList.length) {
          this.$notify.error({ message: '请选择产品' });
          resolve(false);
          return;
        }

        if (summariesData.beforeSplitProductPriceSigle !== summariesData.orderAmount) {
          this.$notify.error({ message: '拆分前单价与订单金额不符' });
          resolve(false);
          return;
        }

        for (let i = 0; i < productList.length; i++) {
          let item = productList[i];
          if (!item.productCode) {
            this.$notify.error({ message: '存在产品未选产品型号' });
            resolve(false);
            return;
          } else if (!item.materialNumberId) {
            this.$notify.error({ message: '存在产品未选择期料号' });
            resolve(false);
            return;
          } else if (!item.expectedDeliveryDate) {
            this.$notify.error({ message: '存在产品未选择期望发货日期' });
            resolve(false);
            return;
          } else if (!item.freightProperty) {
            this.$notify.error({ message: '存在产品未选择货运属性' });
            resolve(false);
            return;
          } else if (!item.rate) {
            this.$notify.error({ message: '存在产品未选择税率' });
            resolve(false);
            return;
          }
        }

        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    },

    // 草稿
    validatedrafts () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();

      return new Promise((resolve) => {
        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    }

  }
};
</script>

<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
</style>
